import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import type { Company, CompanyFormData } from "~/types/contabilidad";

import { EmpresaForm } from "./EmpresaForm";

interface EmpresaDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  company?: Company;
  onSubmit: (data: CompanyFormData) => void;
  isLoading?: boolean;
}

export function EmpresaDialog({
  open,
  onOpenChange,
  company,
  onSubmit,
  isLoading = false,
}: EmpresaDialogProps) {
  const isEditing = !!company;

  const handleSubmit = (data: CompanyFormData) => {
    onSubmit(data);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>
            {isEditing ? "Editar Empresa" : "Nueva Empresa"}
          </DialogTitle>
          <DialogDescription>
            {isEditing
              ? "Modifique los datos de la empresa."
              : "Complete los datos para crear una nueva empresa."}
          </DialogDescription>
        </DialogHeader>

        <EmpresaForm
          initialData={company}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          submitLabel={isEditing ? "Actualizar" : "Crear Empresa"}
        />
      </DialogContent>
    </Dialog>
  );
}
